/**
 * Entry Point: @atlaskit/media-card/types
 * tsconfig.entry-points.json
 */

export var isSSRPreview = function isSSRPreview(preview) {
  return isSSRClientPreview(preview) || isSSRServerPreview(preview) || isSSRDataPreview(preview);
};
export var isSSRServerPreview = function isSSRServerPreview(preview) {
  var ssrClientSources = ['ssr-server', 'cache-ssr-server'];
  return ssrClientSources.includes(preview.source);
};
export var isSSRClientPreview = function isSSRClientPreview(preview) {
  var ssrClientSources = ['ssr-client', 'cache-ssr-client'];
  return ssrClientSources.includes(preview.source);
};
export var isSSRDataPreview = function isSSRDataPreview(preview) {
  return preview.source === 'ssr-data';
};
export var MediaCardCursor = /*#__PURE__*/function (MediaCardCursor) {
  MediaCardCursor["Action"] = "pointer";
  MediaCardCursor["NotReady"] = "wait";
  return MediaCardCursor;
}({});